import { render, staticRenderFns } from "./RegistrarAsignacionItems.vue?vue&type=template&id=5528194b&scoped=true&"
import script from "./RegistrarAsignacionItems.vue?vue&type=script&lang=js&"
export * from "./RegistrarAsignacionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5528194b",
  null
  
)

export default component.exports